import 'array-from-polyfill'
import { getUrlParameter } from '../../../helper-functions'

/**
 * Jobs search state toggle.
 *
 * This code handles the States filtering and the switch from States Cards to the Positions search.
 * It uses a hidden Algolia Widget to filter the states.
 * When a State card is clicked, the algolia widget is clicked programatically.
 */
export default function jobsSearch() {
  /**************************************************************************************
   * Check if the section exists in the page.
   **************************************************************************************/
  const container = document.querySelector( '.js-jobs-search' )

  if ( !container ) {
    return
  }

  /**************************************************************************************
   * Load DOM elements.
   **************************************************************************************/
  const stateMenuWidget = container.querySelector( '.js-jobs-search-menu-widget' )
  const searchTitle = container.querySelector( '.js-jobs-search-title' )
  const algoliaSection = container.querySelector( '.js-jobs-search-algolia-section' )
  const statesSection = container.querySelector( '.js-jobs-search-states-section' )
  const backButton = container.querySelector( '.js-jobs-search-back-button' )
  const cards = container.querySelectorAll( '.js-jobs-search-state-card' )

  /**************************************************************************************
   * State.
   **************************************************************************************/
  /**
   * The selected menu option from the hidden States Algolia widget filter.
   * @type {string}
   */
  let chosenStateOption = ''

  /**************************************************************************************
   * Events.
   **************************************************************************************/
  /**
   * On State card click.
   */
  Array.from( cards ).forEach(
    card => card.addEventListener( 'click', () => {
      const stateTitle = card.querySelector( '.js-position-state-title' )
      selectState( card.dataset.stateId || '', stateTitle && stateTitle.innerHTML || '' )
    })
  )

  /**
   * Show the jobs search if the URL contains the state in a query param.
   */
  const stateNameQueryParam = getUrlParameter( window.location.href, 'state-name' )

  if ( stateNameQueryParam ) {
    searchTitle.innerHTML = stateNameQueryParam
    showSearch()
  }

  /**
   * Event handler for the history onpopstate event.
   * @param {Object} event The event object.
   */
  window.onpopstate = function onPopStateEventListener( event ) {
    filterSearchByState( chosenStateOption )
    if ( !event.state || !event.state.jobHistory ) {
      showCards()
      return
    }

    const stateCard = document.querySelector( `[data-state-id="${event.state.stateId}"]` )
    if ( stateCard ) {
      const title = stateCard.querySelector( 'h3' )
      selectState( event.state.stateId, title.innerHTML || '' )
    }
  }

  /*
   * On back link click.
   */
  backButton.addEventListener( 'click', () => {
    showCards()
    /**
     * Clear the States widget filter.
     */
    filterSearchByState( chosenStateOption )

    /**
     * update history state.
     */
    history.back()
  })

  /**************************************************************************************
   * Functions.
   **************************************************************************************/
  /**
   * Show the jobs search section with a State filtered.
   *
   * @param {string} stateAbbr The state abbreviation.
   * @param {string} stateName The state name.
   */
  function selectState( stateAbbr, stateName ) {
    if ( !stateAbbr || !stateName ) {
      return
    }

    const chosenMenuItem = stateMenuWidget
      .querySelector( `.js-instant-search-menu-item-name[data-id="${ stateAbbr }"]` )

    if ( chosenMenuItem ) {
      chosenStateOption = chosenMenuItem
      filterSearchByState( chosenMenuItem )
      searchTitle.innerHTML = stateName
      history.pushState({ jobHistory: true, stateId: stateAbbr}, stateAbbr, `?state-id=${stateAbbr}` )
      // Set a delay so the Algolia search runs before displaying the section.
      setTimeout( showSearch, 350 )
    }
  }

  /**
   * Click programmatically the Algolia menu widget item to filter the states in the Search.
   *
   * @param {Element} chosenMenuItem The Widget Menu item corresponding to the clicked state.
   */
  function filterSearchByState( chosenMenuItem ) {
    if ( chosenMenuItem ) {
      chosenMenuItem.click()
    }
  }

  /**
   * Show the Algolia search section.
   */
  function showSearch() {
    statesSection.classList.add( 'hidden' )
    algoliaSection.classList.remove( 'hidden' )
  }

  /**
   * Show the cards section.
   */
  function showCards() {
    statesSection.classList.remove( 'hidden' )
    algoliaSection.classList.add( 'hidden' )
  }
}
